/*
validate offfers for item
1. OFFER_TYPE.PERCENTAGE_OFF_ITEM_AND_INGREDIENTS 
2. OFFER_TYPE.PERCENTAGE_OFF_ITEM_OR_INGREDIENTS 
3. OFFER_TYPE.AMOUNT_OFF_ITEM 
4. OFFER_TYPE.PRICE_OVERRIDE_ITEM_OR_INGREDIENT
*/
import * as lodash from 'lodash';

const validateOffersForItem = (
  stagedPurchases: PurchaseWithTotals[],
  selectedOffer: Offer,
): boolean => {
  const { targetPLUs, targetPLUClasses, targetPLUCategories } = selectedOffer;
  if (!targetPLUs && !targetPLUClasses && !targetPLUCategories) return false;
  if (
    (targetPLUs || []).length &&
    (targetPLUClasses || []).length &&
    (targetPLUCategories || []).length
  )
    return false;
  const plus: string[] = [],
    classes: string[] = [],
    categories: string[] = [];
  stagedPurchases.forEach(purchase => {
    const { choicesWithQuantity, item, sizeId } = purchase;
    let _item = item;
    if (item.sizes.length > 0) {
      const sizeItem = item.sizes.find(size => size.id === sizeId);
      if (sizeItem) _item = sizeItem;
    }
    if (_item.plucode) plus.push(_item.plucode);
    if (_item.class) classes.push(_item.class);
    if (_item.category) categories.push(_item.category);

    choicesWithQuantity.forEach(choice => {
      const [_plus, _classes, _categories] =
        getAllPlusClassesCategoriesInPurchase(choice);
      plus.push(..._plus);
      classes.push(..._classes);
      categories.push(..._categories);
    });
  });
  const qualifiedPlus = getUniqArray(plus);
  const qualifiedPlu = searchElementInArrs(qualifiedPlus, targetPLUs);
  if (qualifiedPlu) return true;

  const qualifiedClasses = getUniqArray(classes);
  const qualifiedClass = searchElementInArrs(
    qualifiedClasses,
    targetPLUClasses,
  );
  if (qualifiedClass) return true;

  const qualifiedCagegories = getUniqArray(categories);
  const qualifiedCategory = searchElementInArrs(
    qualifiedCagegories,
    targetPLUCategories,
  );
  if (qualifiedCategory) return true;

  return false;
};

const getAllPlusClassesCategoriesInPurchase = (
  choice: Choice | NestedChoice,
): [string[], string[], string[]] => {
  const plus: string[] = [],
    classes: string[] = [],
    categories: string[] = [];
  if (choice.plucode) plus.push(choice.plucode);
  if (choice.class) classes.push(choice.class);
  if (choice.category) categories.push(choice.category);

  if (lodash.get(choice, 'choiceSets')) {
    const { choiceSets } = choice as NestedChoice;
    choiceSets.forEach(set => {
      (set.choices || []).forEach(choice => {
        const [_plus, _classes, _categories] =
          getAllPlusClassesCategoriesInPurchase(choice);
        if (plus.length > 0) plus.push(..._plus);
        if (classes.length > 0) classes.push(..._classes);
        if (categories.length > 0) categories.push(..._categories);
      });
    });
  }
  return [getUniqArray(plus), getUniqArray(classes), getUniqArray(categories)];
};

const getUniqArray = (arr: any[]): any[] => {
  return lodash.uniq(
    lodash
      .chain(arr)
      .value()
      .filter(e => e),
  );
};

const searchElementInArrs = (source: string[], target: string[]): boolean => {
  return lodash.some(source, s => lodash.includes(target, s));
};

export default validateOffersForItem;
